import { render, staticRenderFns } from "./relationships.vue?vue&type=template&id=30bca468&scoped=true&"
import script from "./relationships.vue?vue&type=script&lang=js&"
export * from "./relationships.vue?vue&type=script&lang=js&"
import style0 from "./relationships.vue?vue&type=style&index=0&id=30bca468&lang=scss&scoped=true&"
import style1 from "./relationships.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bca468",
  null
  
)

export default component.exports